import { Anchor, LinkSVG, NewselaSVG } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
  WithTrackEventProps,
} from "@newsela/snitch";
import { ContentProps } from "@/components/ContentPromotions/types/ContentProps.interface";

import { anchorCss } from "./CustomResourceLink.style";

type AnchorProps = React.ComponentProps<typeof Anchor> | WithTrackEventProps;

const AnchorWithTrackEvent = withTrackEvent(
  Anchor,
) as React.ForwardRefExoticComponent<
  AnchorProps & React.RefAttributes<HTMLAnchorElement>
>;

export const CustomResourceLink = ({ href, title }: ContentProps) => {
  if (!href || !title) return null;

  const isNewselaResource = href?.includes("newsela.com");

  return (
    <AnchorWithTrackEvent
      actionName={actionNames.navigate}
      actionPrefix={actionPrefixes.initiate}
      dataProps={{ "data-qa-selector": "custom-district-resource-link" }}
      href={href}
      isInline
      icon={{
        isIconBeforeText: true,
        removeTextUnderline: true,
        SvgComponent: isNewselaResource ? NewselaSVG : LinkSVG,
      }}
      objectType={objectTypes.content}
      streamProperties={{
        description: `Custom district resource link to ${title ?? ""} promoted at your district`,
      }}
      __cssFor={{
        root: anchorCss,
      }}
    >
      {title}
    </AnchorWithTrackEvent>
  );
};

export default CustomResourceLink;
